export const createSkillApiUrls = {
	createSkill: 'skills',
};
